module.exports = __webpack_public_path__ + "img/logo.0cf3e6e3.svg";